import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../../app/shared/services/user.service";
import { AppService } from "../../../../app/app.service";
import {
  TrainingCategoriesVM,
  TrainingCatgoriesAndSections,
  TrainingCatVM,
  TrainingPreviewVM,
  TrainingSlideSection,
  TrainingVM,
  UserListVM,
} from "../setup-training-types.model";
import { TrainingService } from "../training.service";
import { Location, DatePipe } from "@angular/common";
import { SendTrainingPopupComponent } from "../send-training-popup/send-training-popup.component";
import {
  AnswersOptionsVM,
  QuestionsVM,
  QuestionTypes,
  TrainingInfo,
  TrainingSlidesVM,
  TrainingSubSectionsVM,
} from "../setup-training-types.model";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { LoadingService } from "../../../shared/services/loading.service";
@Component({
  selector: "app-manage-training-activity",
  templateUrl: "./manage-training-activity.component.html",
  styleUrls: ["./manage-training-activity.component.scss"],
})
export class ManageTrainingActivityComponent implements OnInit {
  TrainingTypesAndSections: TrainingCatgoriesAndSections;
  trainingCategories: TrainingCategoriesVM[];
  trainingMainCategories: TrainingCategoriesVM[];
  trainingSections: TrainingCategoriesVM[];
  trainings: TrainingVM[];
  TraingCatList: TrainingCatVM[];
  SubCatId: number;
  clickButton: boolean = false;
  isAdmin: boolean = false;
  UserId: number = 0;
  UserList: UserListVM[];
  isLoggedUser: boolean = false;
  currentVideoUrl: boolean = false;
  trainingStart: boolean = false;
  noVideo: boolean = false;
  @ViewChild("youtubePlayer", { static: false })
  youtubePlayer!: ElementRef<HTMLIFrameElement>;
  showNavigation: boolean = true;
  loading: boolean = false;
  constructor(
    private _route: ActivatedRoute,
    private _dialog: MatDialog,
    private _userService: UserService,
    private _appService: AppService,
    private _trainingService: TrainingService,
    private _router: Router,
    private _location: Location,
    private _sanitizer: DomSanitizer,
    private _loading: LoadingService,
  ) {}

  ngOnInit() {
    this._appService.setPageTitle("Training Activity");
    this.LoadJobRoles();
    this.LoadTrainingCatList();
    this.LoadCatgoriesAndSections();
    this.LoadUserList();
  }

  LoadUserList() {
    this._trainingService.LoadAccesibleUserList().subscribe((res) => {
      this.UserList = res;
    });
  }
  LoadCatgoriesAndSections() {
    this.loading = true;
    this._loading.startLoading();
    this._trainingService
      .GetTrainingTypesAndSectionsForUser(this.UserId)
      .subscribe((res) => {
        console.log("resulr__", res);
        this.TrainingTypesAndSections = res;
        this.trainingMainCategories =
          this.TrainingTypesAndSections.MainParentCategories;
        this.trainingCategories =
          this.TrainingTypesAndSections.ParentCategories;
        this.trainingSections = this.TrainingTypesAndSections.CategorySections;
        this.trainings = this.TrainingTypesAndSections.Trainings;
        this.isLoggedUser = this.TrainingTypesAndSections.isLoggedUser;
        this.loading = false;
        this._loading.finishedLoading();
        if(!this.lastSectionVideo) {
          if (this.trainingTypeId) {
          const section = this.trainingSections?.find(x => x.TrainigCatId == this.trainingTypeId);
          if (section) {
            section.isExpanded = true;
          }
        } 
      }
      this.lastSectionVideo = false;
    });
  }

  LoadTrainingCatList() {
    this._trainingService.GetTrainingSubTypes().subscribe((res) => {
      // console.log("TraingCatList", res)
      this.TraingCatList = res;
    });
  }

  FilterTraingsBySubCatId(SelectedSubInfo: TrainingCatVM) {
    // console.log("SelectedSubInfo", SelectedSubInfo)
    this._trainingService
      .GetTrainingTypesAndSectionsForUser(this.UserId)
      .subscribe((res) => {
        console.log("resulr__", res);
        this.TrainingTypesAndSections = res;
        this.trainingMainCategories =
          this.TrainingTypesAndSections.MainParentCategories.filter(
            (x) => x.TrainigCatId == SelectedSubInfo.MainParentId,
          );
        this.trainingCategories =
          this.TrainingTypesAndSections.ParentCategories.filter(
            (x) => x.TrainigCatId == SelectedSubInfo.ParentId,
          );
        this.trainingSections =
          this.TrainingTypesAndSections.CategorySections.filter(
            (x) => x.TrainigCatId == SelectedSubInfo.Id,
          );
        this.trainings = this.TrainingTypesAndSections.Trainings.filter(
          (x) => x.TrainingTypeId == SelectedSubInfo.Id,
        );
        this.isLoggedUser = this.TrainingTypesAndSections.isLoggedUser;
        // console.log("trainingMainCategories", this.trainingMainCategories)
        // console.log("trainingCategories", this.trainingCategories)
        // console.log("trainingSections", this.trainingSections)
        // console.log("trainings", this.trainings)
      });
  }
  SubCatSelect(SelectedSubInfo: any) {
    if (this.SubCatId > 0) {
      this.FilterTraingsBySubCatId(SelectedSubInfo);
    } else {
      this.LoadCatgoriesAndSections();
    }
  }

  LoadJobRoles() {
    this._userService.getUserJobRoles().subscribe((roles) => {
      roles.forEach((r) => {
        switch (r.Name) {
          case "Inspectors":
            //this.isJobRoleDefault = false;
            //this.isAdmin=false;
            break;
          case "Interpreters":
            //this.isJobRoleDefault = false;
            break;
          case "Super User":
            //this.isJobRoleDefault = false;
            break;
          case "Administrator":
            ///this.isJobRoleDefault = false;
            this.isAdmin = true;
            break;
          case "Customer Admin":
            this.isAdmin = true;
            break;
          case "Supervisor":
            // this.isJobRoleDefault = false;
            this.isAdmin = true;
            break;
        }
      });
    });
  }

  StartTraining(status: number, traingId: number, sessionId: number, trainingTypeId:number) {
    if (this.isLoggedUser) {
      this.showNavigation = true;
      console.log("same user");
      //this.r.navi('start-training/' + this.UserId +"/"+ traingId);
      if (status == 0) {
        this.trainingStart = true;
        this.TrainingId = traingId;
        this.sessionID = sessionId;
        this.isSectionQView = false;
        this.getUserNameAndTrainingName();
        this.currentTrainingId = traingId;
        this.currentSessionId = sessionId;
        const training = this.trainings.find(x => x.TrainingId == traingId);
        if (training) {
          training.Status = 1;
        }
        //this._router.navigate(['start-training', this.UserId,traingId]);
      }
      if (status == 1) {
        //this._router.navigate(['training-session', sessionId,traingId]);
        this.LoadTrainingDetails(traingId, sessionId);
        this.currentTrainingId = traingId;
        this.currentSessionId = sessionId;
        const training = this.trainings.find(x => x.TrainingId == traingId);
        if (training) {
          training.Status = 1;
        }
      }
      if (status == 2) {
        this.WarningNotification(traingId, this.UserId);
        //this.trainingStart = true;
        this.TrainingId = traingId;
        this.sessionID = sessionId;
        this.isSectionQView = false;
        this.getUserNameAndTrainingName();
        this.currentTrainingId = traingId;
        this.currentSessionId = sessionId;
        //this._router.navigate(['training-session', sessionId,traingId]);
      }
      this.noVideo = false;
      this.lastSectionVideo = false;
    } else {
      console.log("Differnt user");
    }
  }

  SelectUser() {
    this.SubCatId = 0;
    console.log(" this.UserId", this.UserId);
    this.LoadCatgoriesAndSections();
  }

  ForwardEmail(traingId: number) {
    const addSectionDialog = this._dialog.open(SendTrainingPopupComponent, {
      data: {
        TrainingId: traingId,
        sendEmail: true,
      },
    });
    addSectionDialog.afterClosed().subscribe((details) => {
      if (details == true) {
        //this.LoadTrainingQuestionsList();
      }
    });
  }

  WarningNotification(traingId: number, userId: number) {
    const addSectionDialog = this._dialog.open(SendTrainingPopupComponent, {
      data: {
        TrainingId: traingId,
        sendEmail: false,
        warning: true,
        userId: userId,
        Route: false
      },
    });
    addSectionDialog.afterClosed().subscribe((details) => {
      if (details == true) {
        //this.LoadTrainingQuestionsList();
        this.trainingStart = true;
      }
    });
  }

  //for right side data
  selectedwith: string = "0%";
  selectedwithNumber: number = 0;
  TrainingCategories: TrainingCatVM[];
  TrainingId: number = 0;
  TrainingInfo: TrainingInfo;
  Sections: TrainingSubSectionsVM[];
  Slides: TrainingSlidesVM[];

  SlideInfo: TrainingSlidesVM;
  sessionID: number = 0;
  QuestionTypes: QuestionTypes[];
  TrainingQuestions: QuestionsVM[];

  TrainingQuestions_: QuestionsVM[];

  selectedSlide: string;

  isURL: boolean = false;
  SectionId: number;
  sectionName: string;
  isPrevious: boolean = false;
  isNext: boolean = false;
  isSQuestion: boolean = false;
  sectionSlides: TrainingSlidesVM[];
  currentSlideId: number;
  isSectionQView: boolean = false;
  hasInvalidQ: boolean = false;
  totalClicksCount: number = 0;
  TotalCount: number = 0;
  isURL_: boolean = false;
  selectedSlide_: string;
  showslide: boolean = false;
  show: boolean = false;
  gotoNextSection: boolean = false;
  FinishTrainig: boolean = false;
  username: string;
  training: string;
  previewInfo: TrainingPreviewVM;
  LoadTrainingDetails(traingId: number, sessionId: number) {
    this._trainingService.LoadTraining(traingId).subscribe((res) => {
      console.log("result_tarining sections", res);
      this.TrainingInfo = res;
      this.Sections = this.TrainingInfo.SubTrainings;
      this.Slides = this.TrainingInfo.Slides;
      this.QuestionTypes = this.TrainingInfo.QuestionTypes;
      this.TrainingQuestions_ = this.TrainingInfo.TrainingQuestions;
      this.TrainingQuestions_ = this.TrainingQuestions_.map(x => ({ ...x, Invalid: false }));
      //progress bar
      this.totalClicksCount = this.Slides.length + this.Sections.length;
      let oneclickvalue = Math.round(100 / this.totalClicksCount);
      this.TotalCount = this.TotalCount + 1;
      this.selectedwithNumber = oneclickvalue * this.TotalCount;
      this.selectedwith = this.selectedwithNumber.toString() + "%";
      this.NextTrainingId = res.NextTrainingId;
      //first load
      let copySlides = [...this.Slides];
      this.SectionId = this.Sections[0]?.TrainigSubId;
      this.sectionName = this.Sections[0]?.TrainigSubName;

      var filtedredSlides = copySlides?.filter(
        (x) => x.SubSectionId == this.SectionId,
      );
      this.sectionSlides = copySlides?.filter(
        (x) => x.SubSectionId == this.SectionId,
      );
      this.currentSlideId = filtedredSlides[0]?.SlideId;
      this.isURL = filtedredSlides[0]?.isLink;
      this.selectedSlide =
        this.isURL == true
          ? filtedredSlides[0]?.YoutubeLink
          : filtedredSlides[0]?.SlideImage;
      //console.log("isURL", this.isURL, this.selectedSlide)

      let copyQuestions = [...this.TrainingQuestions_];
      var filterQuestions = copyQuestions?.filter(
        (x) => x.SubSectionId == this.SectionId,
      );
      if (filtedredSlides?.length > 0) {
        this.isNext = true;
      }

      if (filterQuestions?.length > 0) {
        this.isSQuestion = true;
      }
      if(this.Slides.length==0){
        this.currentVideoUrl = false;
        this.noVideo = true;
      }

      this.currentVideoUrl = true;
      this.isSectionQView = false;
      this.sessionID = sessionId;
      this.trainingStart = false;
      this.hasInvalidQ = false;
      this.questionsAnsweredCorrectly = false;
      this.FinishTrainig = false;
      this.gotoNextSection = false;
      // Add this line
      if (this.isURL) {
        this.setYoutubeUrl(filtedredSlides[0]?.YoutubeLink);
      }
    });
  }

  sanitize(image: string) {
    if (!image || image.trim() === '') {
      return null;
    }
    return this._sanitizer.bypassSecurityTrustUrl(
      `data:image/*;base64,${image}`,
    );
  }

  // LoadURL(url: string) {
  //   console.log(url)
  //   return this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${url}?enablejsapi=1&origin=${window.location.origin}`);
  // }

  private playerReady = false;
  safeYoutubeUrl: SafeResourceUrl | null = null;

  // Call this when you set a new video, not in the template
  setYoutubeUrl(url: string) {
    this.playerReady = false;
    this.safeYoutubeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${url}?enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}&rel=0&modestbranding=1`,
    );
  }

  onIframeLoad() {
    // Give the YouTube API a moment to initialize after iframe loads
    setTimeout(() => {
      this.playerReady = true;
    }, 500);
  }

  private sendYouTubeCommand(func: "playVideo" | "pauseVideo") {
    if (!this.isURL || !this.playerReady) return;
    const iframe = this.youtubePlayer?.nativeElement;
    if (!iframe) return;

    iframe.contentWindow?.postMessage(
      JSON.stringify({ event: "command", func, args: [] }),
      "https://www.youtube.com", // must be YouTube's origin, not yours
    );
  }

  playVideo() {
    this.sendYouTubeCommand("playVideo");
  }

  pauseVideo() {
    this.sendYouTubeCommand("pauseVideo");
  }

  closeVideo() {
    this.currentVideoUrl = false;
    // this.selectedSlide = null;
    // this.isURL = false;
  }

  quizSection() {
    this.currentVideoUrl = false;
    this.SectionQuestions();
  }

  SectionQuestions() {
    this.LoadQuestions();
    this.show = true;
    this.isSectionQView = true;
    let oneclickvalue = Math.round(100 / this.totalClicksCount);
    this.TotalCount = this.TotalCount + 1;
    this.selectedwithNumber = oneclickvalue * this.TotalCount;
    this.selectedwith = this.selectedwithNumber.toString() + "%";
  }

  TrainingQuestionsCopy: QuestionsVM[];
  LoadQuestions() {
    this._trainingService
      .LoadQuestionInfForSection(this.SectionId)
      .subscribe((res) => {
        this.TrainingQuestions = res;
        this.TrainingQuestionsCopy = [...this.TrainingQuestions];
        //this.isSectionQView = true;
      });
  }
GotoReleventSlide(slideid: number) {
  this.LoadTrainingDetails(slideid, this.sessionID);
}
  SelectAnswerRadio(selectitem: AnswersOptionsVM, question: QuestionsVM) {
    //console.log("event_radio11111", event.target)
    this.TrainingQuestionsCopy.map((q) => {
      if (q.QuestionId == question.QuestionId) {
        q.AnswerList.map((x) => {
          if (x.Id == selectitem.Id) {
            x.UserSelect = true;
          } else {
            x.UserSelect = false;
          }
        });
      }
    });
  }
  SelectAnswerMutipleSelection(
    question: QuestionsVM,
    selectitem: AnswersOptionsVM,
  ) {
    console.log("event_msq =", selectitem);
    //let copy_ = [...this.TrainingQuestions];
    this.TrainingQuestionsCopy.map((q) => {
      if (q.QuestionId == question.QuestionId) {
        q.AnswerList.map((x) => {
          if (x.Id == selectitem.Id) {
            x.UserSelect = !x.UserSelect;
          }
        });
      }
    });
    // this.TrainingQuestions = copy_
  }
  questionsAnsweredCorrectly: boolean = false;
  submitAnswers() {
    //this.show=false;
    console.log("questions", this.TrainingQuestionsCopy);
    //this.hasInvalidQ=false;
    this.TrainingQuestionsCopy.map((q) => {
      q.Invalid = false;
      if (q.QuestionTypeId != 3) {
        let isInvalid = q.AnswerList.find((x) => x.Select != x.UserSelect);
        if (isInvalid) q.Invalid = true;
        // this.hasInvalidQ=true
      }
      if (q.QuestionTypeId == 3) {
        let count = 0;
        q.AnswerList.map((x) => {
          if (x.Select == true && x.UserSelect == true) {
            count = count + 1;
          }
          if (x.Select == false && x.UserSelect == true) {
            q.Invalid = true;
            //this.hasInvalidQ=true
          }
        });

        if (count < q.AnswerCount && q.Invalid == false) {
          q.Invalid = true;
          // this.hasInvalidQ=true
        }
      }
    });
    let hasInvalidQ = this.TrainingQuestionsCopy.find((x) => x.Invalid == true);
    if (hasInvalidQ) {
      this.hasInvalidQ = true;
      this.questionsAnsweredCorrectly = false;
    } else {
      this.hasInvalidQ = false;
      this.questionsAnsweredCorrectly = true;
      //need to check it has another section

      let index = this.Sections.findIndex(
        (x) => x.TrainigSubId == this.SectionId,
      );
      let section = this.Sections[index + 1];
      if (section) {
        this.TrainingQuestions = null;
        this.showslide = false;
        this.show = false;
        this.gotoNextSection = false;
        this.FinishTrainig = false;

        console.log("hasSection", section);
        this.SectionId = section.TrainigSubId;
        this.sectionName = section.TrainigSubName;
        let copySlides = [...this.Slides];
        var filtedredSlides = copySlides.filter(
          (x) => x.SubSectionId == this.SectionId,
        );
        this.sectionSlides = copySlides.filter(
          (x) => x.SubSectionId == this.SectionId,
        );
        this.currentSlideId = filtedredSlides[0].SlideId;
        this.isURL = filtedredSlides[0].isLink;
        this.selectedSlide =
          this.isURL == true
            ? filtedredSlides[0].YoutubeLink
            : filtedredSlides[0].SlideImage;
        console.log("isURL", this.isURL, this.selectedSlide);

        let copyQuestions = [...this.TrainingQuestions_];
        var filterQuestions = copyQuestions.filter(
          (x) => x.SubSectionId == this.SectionId,
        );
        if (filtedredSlides.length > 0) {
          this.isNext = true;
        }

        if (filterQuestions.length > 0) {
          this.isSQuestion = true;
        }

        this.isSectionQView = false;
        //this.gotoNextSection=true;
        console.log("Goto Next Section");
      } else {
        this.FinishTrainig = true;
        this.gotoNextSection = true;

        //progress bar 100%
        let oneclickvalue = Math.round(100 / this.totalClicksCount);
        this.TotalCount = this.TotalCount + 1;
        this.selectedwithNumber = oneclickvalue * this.TotalCount;
        this.selectedwith = "100%";

        //this.isSectionQView=false;
        console.log("Training Done");
      }
    }
    this.TrainingQuestions = this.TrainingQuestionsCopy;
  }

  finishTraining() {
    this._trainingService
      .UpdateTrainingSessionComplete(this.sessionID)
      .subscribe((res) => {
        if (res == true) {
          this.currentVideoUrl = false;
          this.isSectionQView = false;
          this.questionsAnsweredCorrectly = false;
          this.LoadCatgoriesAndSections();
          this.nextSection(this.NextTrainingId);
          //this._router.navigate(['training-activity']);
        }
      });
  }
  startTraining() {
    this.trainingStart = false;
    this.startNewTraining(this.TrainingId);
    this.LoadCatgoriesAndSections();
  }

  startNewTraining(trainingId: number){
    this._trainingService.StartNewTrainingSession(trainingId).subscribe(res=>{
      console.log("result_start", res)
      if(res.m_Item1 > 0) {
        this.LoadTrainingDetails(this.TrainingId, res.m_Item1);
      }
    });
  }

  getUserNameAndTrainingName() {
    this._trainingService.GetSelectedTrainingPreviewInfo(this.TrainingId, this.UserId)
    .subscribe((res) => {
      this.previewInfo = res;
      this.username = this.previewInfo.UserName;
      this.training = this.previewInfo.TrainingType + " - " + this.previewInfo.TrainingName;
    });
  }

 orderedTrainingList: any[] = [];
currentTrainingId: number;
currentSessionId: number;

NextTrainingId: number;
CurrentTraining: TrainingSlideSection;
lastSectionVideo: boolean = false;

  nextSection(trainingId:number) {
    if(this.lastSectionVideo){
      //this.finishTraining();
      if (this.trainingTypeId) {
        const section = this.trainingSections?.find(x => x.TrainigCatId == this.trainingTypeId);
        if (section) {
          section.isExpanded = false;
        }
      }
      this.noVideo = false;
      this.currentVideoUrl = false;
      this.isSectionQView = false;
      this.trainingStart  = false;
      this.showNavigation = false;
      return;
    }
    this.noVideo = false;
    this._trainingService.getSelectedTrainingSlides(trainingId)
    .subscribe(res => {
      console.log("training response",res);
       this.TrainingInfo = res;
        this.Sections = this.TrainingInfo.SubTrainings;
        this.Slides = this.TrainingInfo.Slides;
        this.QuestionTypes = this.TrainingInfo.QuestionTypes;
        this.TrainingQuestions_ = this.TrainingInfo.TrainingQuestions;
        this.CurrentTraining = this.TrainingInfo.CurrentTraining;
        this.NextTrainingId = res.NextTrainingId;
        this.lastSectionVideo = res.FinishTraining;
        this.totalClicksCount = this.Slides.length + this.Sections.length;
        let oneclickvalue = Math.round(100 / this.totalClicksCount);
        this.TotalCount = this.TotalCount + 1;
        this.selectedwithNumber = oneclickvalue * this.TotalCount;
        this.selectedwith = this.selectedwithNumber.toString() + "%";
        //first load
        let copySlides = [...this.Slides];
        this.SectionId = this.Sections[0]?.TrainigSubId;
        this.sectionName = this.Sections[0]?.TrainigSubName;
        this.sectionName = this.sectionName == undefined ? this.CurrentTraining.Title : this.sectionName;

        var filtedredSlides = copySlides?.filter(
          (x) => x.SubSectionId == this.SectionId,
        );
        this.sectionSlides = copySlides?.filter(
          (x) => x.SubSectionId == this.SectionId,
        );
        this.currentSlideId = filtedredSlides[0]?.SlideId;
        this.isURL = filtedredSlides[0]?.isLink;
        this.selectedSlide =
          this.isURL == true
            ? filtedredSlides[0]?.YoutubeLink
            : filtedredSlides[0]?.SlideImage;
        //console.log("isURL", this.isURL, this.selectedSlide)

        let copyQuestions = [...this.TrainingQuestions_];
        var filterQuestions = copyQuestions?.filter(
          (x) => x.SubSectionId == this.SectionId,
        );
        if (filtedredSlides?.length > 0) {
          this.isNext = true;
        }

        if (filterQuestions?.length > 0) {
          this.isSQuestion = true;
        }
        if(this.Slides.length==0){
          this.currentVideoUrl = false;
          this.noVideo = true;
        }

        this.currentVideoUrl = true;
        this.isSectionQView = false;
        //this.sessionID = sessionId;
        this.trainingStart = false;
        this.hasInvalidQ = false;
        this.questionsAnsweredCorrectly = false;
        this.FinishTrainig = false;
        this.gotoNextSection = false;
        // Add this line
        if (this.isURL) {
          this.setYoutubeUrl(filtedredSlides[0]?.YoutubeLink);
        }
    });
  }

  trainingTypeId:number;

  togglePanel(section: TrainingCategoriesVM) {
    this.trainingSections.forEach(x => x.isExpanded = false);
    section.isExpanded = true; 
    this.trainingTypeId = section.TrainigCatId;
  }
}
